import axios from 'axios'
import Logger from './Logger'

axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT;
axios.defaults.auth = {
    username: process.env.VUE_APP_HTTP_USERNAME,
    password: process.env.VUE_APP_HTTP_PASSWORD
};
axios.defaults.headers.common['x-mvident'] = "-";


const ApiClient = {
    methods: {
        getProducts(brand) {
            Logger.debug("ApiClient::getProducts");
            return axios.get(process.env.VUE_APP_API_ENDPOINT + '/jsmd/available-products', {
                headers: {'x-mvident': brand },
                auth: {
                    username: process.env.VUE_APP_HTTP_USERNAME,
                    password: process.env.VUE_APP_HTTP_PASSWORD
                }
            })
        },
        validateCode(payload) {
            Logger.debug("ApiClient::validateCode");
            return axios.post(
                process.env.VUE_APP_API_ENDPOINT + '/jsmd/validate-code',
                payload,
                {
                    headers: {'x-mvident': payload.brand},
                    auth: {
                        username: process.env.VUE_APP_HTTP_USERNAME,
                        password: process.env.VUE_APP_HTTP_PASSWORD
                    }
                }
            )
        },
        sendRequestData(payload) {
            Logger.debug("ApiClient::sendRequestData");
            return axios.post(
                process.env.VUE_APP_API_ENDPOINT + '/jsmd/send-request',
                payload,
                {
                    headers: { 'x-mvident': payload.brand },
                    auth: {
                        username: process.env.VUE_APP_HTTP_USERNAME,
                        password: process.env.VUE_APP_HTTP_PASSWORD
                    }
                }
            )
        },
        distinct(list, extractor) {
            let visited = new Set();
            let result = [];
            for (const item of list) {
                let key = extractor(item);
                if (!visited.has(key)) {
                    visited.add(key);
                    result.push(item);
                }
            }
            return result;
        },
        parseDate(value) {
            if (value === '' || value === undefined || value === null) {
                return null;
            }
            if (typeof value === "string") {
                let parts = value.split('.');
                return new Date(parseInt(parts[2]), parseInt(parts[1])-1, parseInt(parts[0]), 0, 0, 0, 0);
            }
            return null;
        },
        formatDate(value) {
            if (value === '' || value === undefined || value === null) {
                return null;
            }
            return ((value.getDate() < 10 ? "0": "") + value.getDate()) + "." + ((value.getMonth()<9? "0": "") + (value.getMonth()+1)) + "." + value.getFullYear();
        }
    }
};
export default ApiClient



